




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Uploader } from "vant";
import lrz from "lrz";

@Component({
  components: {
    [Uploader.name]: Uploader
  }
})
export default class CustomUploader extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private value;
  @Prop({
    type: String,
    default: ""
  })
  private title;
  @Prop({
    type: String,
    default: ""
  })
  private backgroundImg;

  uploadImg = "";

  @Watch("value", { deep: true, immediate: true })
  watchValue(val) {
    this.uploadImg = val.url;
  }

  handleUpload(file) {
    const params = new FormData();
    lrz(file.file, {
      quality: 0.5
    })
      .then(compressRes => {
        
        params.append("file", compressRes.file);
        params.append("put_dir", "gygjqh_id_card");
        (this as any).$apis
          .uploadFile(params)
          .then(res => {
            // this.base64 = compressRes.base64;
            this.uploadImg = compressRes.base64;
            
            this.$emit("afterUpload", res);
            this.$emit("input", res);
          })
          .catch(err => {
            
          });
      })
      .catch(err => {
        
      });
  }

  handleReset() {
    this.uploadImg = "";
    this.$emit("input", {});
  }
}
